module.exports = __webpack_public_path__ + "static/media/bicoArticuladoTT.6c9df6e0.png";